<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header
    class="mcd-card-header"
    style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393f;
      border-left: none;
    "
  >
    <mat-card-title class="mcd-card-title">View All Standard</mat-card-title>
  </mat-card-header>
  <div class="breadcrumbs clearfix">
    <div class="breadcrumbs-inner">
      <ul>
        <li>
          <a routerLink="/locations" routerLinkActive="active">Locations</a>
        </li>
        <li class="separator">></li>
        <li class="active">{{ locationName }}</li>
      </ul>
    </div>
  </div>
  <mat-card-content class="mcd-card-content">
    <div
      class="row filter-panel-row"
      style="align-items: center; margin-bottom: 20px; display: flex; justify-content: space-between;"
    >
      <div class="col-auto d-flex align-items-center" style="display: flex; gap: 15px; flex-wrap: wrap;">
        <!-- Search Input matching Suppliers list -->
        <div class="mcd-filter-dropdown-wrapper search-wrapper">
          <div class="mcd-search-header">
            <mat-icon
              class="search-icon"
              style="cursor: pointer;"
              (click)="addSearchKey(key.value)"
            >search</mat-icon>
            <input
              type="text"
              placeholder="Type to search...."
              class="search-input-field"
              [value]="searchKey || ''"
              (keyup.enter)="addSearchKey(key.value)"
              (input)="onSearchInput(key.value)"
              #key
            />
            <button
              type="button"
              class="clear-button"
              *ngIf="key.value"
              (click)="key.value = ''; searchKey = ''; addSearchKey('')"
              aria-label="Clear search"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <!-- Category Filter Dropdown Pill Component -->
        <app-view-all-mnimum-sandard-list-filter
          [isFromLocation]="isFromLocation"
          (messageEvent)="receivedFilteration($event)"
        ></app-view-all-mnimum-sandard-list-filter>
      </div>
    </div>

    <div
      class="table-wrapper"
      *ngIf="grses.length > 0"
    >
      <table class="table nrbes-grid" matSort (matSortChange)="sortData($event)">
        <thead class="thead-light">
          <tr>
            <th width="22%" scope="col" mat-sort-header="title">Title</th>
            <th width="15%" scope="col">Location</th>
            <th width="25%" scope="col" mat-sort-header="category">Category</th>
            <th width="38%" scope="col" mat-sort-header="desc">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of grses" (click)="rowSelected(item)">
            <td
              class="location-cell"
              style="font-weight: 500; color: #3949a3; font-size: 14px;"
            >
              {{ item.title }}
            </td>
            <td style="color: #475569; font-size: 14px;">
              {{ getLocationNames(item) }}
            </td>
            <td style="color: #475569; font-size: 14px;">
              {{ item.category?.name }}
            </td>
            <td class="description">
              <span title="{{ item.shortDescription }}" class="description">
                {{ item.shortDescription }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 15px;
        "
        *ngIf="grses.length > 0"
      >
        <div>
          <mat-form-field>
            <mat-select
              style="
                padding: 8px 16px;
                border: 1px solid #dde1e6;
                border-radius: 4px;
                background-color: #f8fafb;
                color: #4d5258;
                font-weight: 500;
              "
              [value]="pageSize"
              name="nOfRows"
              #items
              (selectionChange)="selectedItemsPerPageChange(items)"
            >
              <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <ngb-pagination
            class="float-right"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="4"
            [rotate]="true"
            [ellipses]="true"
            [collectionSize]="collectionSize"
            (pageChange)="getStandards()"
          ></ngb-pagination>
        </div>

        <div style="display: flex; gap: 10px">
          <button
            class="prevButton"
            [ngStyle]="{
              border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == 1 ? '#696F77' : '#34393f'
            }"
            (click)="goToPreviousPage()"
          >
            <img src="/assets/images/leftarrow.svg" />
            Previous
          </button>
          <button
            class="nextButton"
            [ngStyle]="{
              border: page == totalPages ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == totalPages ? '#696F77' : '#34393f'
            }"
            (click)="goToNextPage()"
          >
            Next
            <img src="/assets/images/rightarrow.svg" />
          </button>
        </div>
      </div>
    </div>

    <div
      *ngIf="grses.length == 0 && searchKey"
      class="search-empty-state"
    >
      <img
        src="/assets/images/GRBES-List.svg"
        alt=""
        class="search-empty-icon"
      />
      <h4 class="search-empty-title">No results found</h4>
      <p class="search-empty-subtitle">
        Try a different keyword or refine your search to find what you're
        looking for.
      </p>
    </div>
    <div class="noResults" *ngIf="grses.length == 0 && !searchKey">
      No results found based on search terms.
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
